export enum AppRouteLink {
    ESTIMATE = 'estimate',
    TREATMENTEVOLUTION = 'treatment-evolution/signatures',
    ANAMNESE = 'anamnese',
    TEXT = 'text',
}